module.exports = __webpack_public_path__ + "static/media/down_arrow.30e7221f.png";